import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListNotices from './submodules/list/List';
import CloneNotice from './submodules/clone/Clone';
import launchWidgetCloneNotice from './submodules/launchWidget/clone';
import EditNotice from './submodules/edit/Edit';
import LaunchWIdgetEditNotice from './submodules/launchWidget/edit/Edit';
import CreateNotice from './submodules/create/Create';
import createLaunchWidget from './submodules/launchWidget/create';
import SelectWidgetType from './submodules/WidgetTypes/widgetType';

const NoticeDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.notices}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].getNotices]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListNotices}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.notices}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].createNotice]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneNotice}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.notices}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].createNotice]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/launchWidgetClone`}
				component={launchWidgetCloneNotice}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.notices}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].createNotice]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateNotice}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.notices}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].createNotice]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/createLaunchWidget`}
				component={createLaunchWidget}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.notices}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].selectWidgetType]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/selectWidgetType`}
				component={SelectWidgetType}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.notices}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].updateNotice]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditNotice}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.notices}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].updateNotice]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/launchWidgetEdit`}
				component={LaunchWIdgetEditNotice}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default NoticeDashboard;
